import { Button, required, useNotify, useRefresh } from "react-admin";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { studentRequests } from "api/studentApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const SetYoungChildrenMothersDialog = ({ studentId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleYoungChildrenMothersSet = async data => {
    const payload = { studentId, childBirthDate: data.childBirthDate };
    await dataProvider.customRequest(studentRequests.setYoungChildrenMother(), payload, "PUT");
    refresh();
    notify(`Успешно отбелязахте студента като "Майка с малки деца"`, { type: "success" });
  };

  return (
    <FormModal
      titleContent="Майка с малки деца"
      onConfirm={handleYoungChildrenMothersSet}
      defaultValues={{ childBirthDate: null }}
      triggerButton={
        <Button
          label="Майка с малки деца"
          variant="contained"
          startIcon={<BabyChangingStationIcon />}
        />
      }
    >
      <CustomDateInput
        label="Дата на раждане на детето"
        source="childBirthDate"
        validate={required("Моля, въведете дата на раждане на детето.")}
        noTime
        required={true}
      />
    </FormModal>
  );
};

export default SetYoungChildrenMothersDialog;
